import { Outlet, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useAuth } from '@/hooks/useAuth';
import { usePermissionsStore } from '@/stores/permissions';
import { Header } from '@/components/ui/Header';
import { DevPersonaSwitcher } from '@/components/ui/DevPersonaSwitcher';
import { InstallerBottomNav } from '@/components/ui/InstallerBottomNav';
import { InstallerDesktopNav } from '@/components/ui/InstallerDesktopNav';
import { SentryErrorFallbackAdapter } from '@/components/ui/ErrorFallback';

export function InstallerShell() {
  const { authError, initializing } = useAuth();
  const location = useLocation();
  const permissions = usePermissionsStore((s) => s.permissions);

  // Show loading while OIDC redirect is being prepared or permissions loading
  if (initializing || (!permissions && !authError)) {
    return (
      <div className="min-h-screen bg-td-bg font-sans flex items-center justify-center">
        <p className="text-td-muted text-sm">Bezig met inloggen...</p>
      </div>
    );
  }

  if (authError) {
    return (
      <div className="min-h-screen bg-td-bg font-sans flex items-center justify-center p-8">
        <div className="bg-white rounded-xl shadow-md p-8 max-w-md text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-lg font-bold text-td-navy mb-2">Authenticatie vereist</h1>
          <p className="text-sm text-td-muted">{authError}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-td-bg font-sans">
      <Header />
      <InstallerDesktopNav />
      <main className="pb-20 lg:pb-0">
        <Sentry.ErrorBoundary key={location.pathname} fallback={SentryErrorFallbackAdapter}>
          <Outlet />
        </Sentry.ErrorBoundary>
      </main>
      <InstallerBottomNav />
      <DevPersonaSwitcher />
    </div>
  );
}
